/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "boleta-sii-prod",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1tkunpsy3zkzt.cloudfront.net",
    "aws_cloud_logic_custom": [
        {
            "name": "apiBoletaSII",
            "endpoint": "https://q0pwrt48l5.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "apiAuthSII",
            "endpoint": "https://x78kr8nqx5.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "notificaciones",
            "endpoint": "https://s0p3uy3jwi.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "eBoletaActualizador",
            "endpoint": "https://tz246sanri.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "apiConfiguracion",
            "endpoint": "https://76n86hwd0g.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        },
        {
            "name": "apiConfiguracionUsuario",
            "endpoint": "https://cunz2isut6.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:e154b392-0e4e-47ad-a68f-5c814f8e3eb5",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6cKII12uo",
    "aws_user_pools_web_client_id": "10bbim766s7jvka7ibatpmsr39",
    "oauth": {}
};


export default awsmobile;
